import { useLayoutEffect } from "react";
import { useLocation } from "react-router";

export default function ScrollToTop() {
    const { pathname } = useLocation();

    useLayoutEffect(() => {
        pathname === "/" ? window.scrollTo(0, 0) : scrollToNav();
    }, [pathname]);

    return null;
}
const scrollToNav = () => {
    const header = document.getElementsByTagName("header")[0] as HTMLElement;
    if (!header) return;
    // header.scrollIntoView({ behavior: "smooth" });
    window.scrollTo({ left: 0, top: header.offsetTop, behavior: "smooth" });
};

export { scrollToNav };
